import type Api from ".";

export default (api: typeof Api) => ({
    getPatientsAppointment: () =>
        api.get(`api/customers/appointments/my_appointments`, {}, {}),
    getAppointmentDetails: (appointmentId: string) =>
        api.get(`api/customers/appointments/${appointmentId}`, {}, {}),
    submitAppointmentFeedback: (data: any) =>
        api.post(`api/customers/feedbacks`, {}, data),
    followUpAppointment: (data: any) =>
        api.post(`api/customers/appointments/follow_up`, {}, data),
    requestPhoneCall: (data: FormData) => {
        for (let [key, value] of data.entries()) {
            console.log(key, value);
        }

        return api.post(
            `api/customers/call_requests/request_call_back`,
            data,
            data
        );
    },
    getIssuesList: (teamName: string) =>
        api.get(
            `api/customers/call_requests/task_list_for_call_request`,
            {
                team_name: teamName,
            },
            {}
        ),
    getInvoicePDF: (appointmentId: number) =>
        api.get(
            `api/customers/invoices/get_invoice_pdf`,
            {
                appointment_id: appointmentId,
            },
            {}
        ),
    optAppointmentSecondaryServices: (data: any) =>
        api.put(`api/customers/appointments/opted_secondary_services`, {}, data),
    bookFollowUpAppointment: (id: number | string) =>
        api.post(
            `api/customers/follow_up_appointment`,
            {},
            {
                appointment_id: Number(id),
            }
        ),
    getAllQueries: () =>
        api.get(`api/customers/customer_tickets/customer_tickets`, {}, {}),
    getQueryDetails: (queryId: number) =>
        api.get(
            "api/customers/customer_tickets/customer_ticket_details",
            {
                id: queryId,
            },
            {}
        ),
    submitQueryFeedback: (data: any) =>
        api.post(`api/customers/customer_tickets/submit_feedback`, {}, data),
    sendAppointmentInstructions: (data: any) =>
        api.put(`api/customers/appointments/add_instructions_for_doctor`, {}, data),
});
